import { createFileRoute } from '@tanstack/react-router'
import { requireSuperAdmin } from '@/shell/session'
import { z } from 'zod'
import { Globe } from 'lucide-react'
import { PlatformControlScreen } from '@/screens/platform/SCR-059-platform-control'

// SCR-059 Platform control (platform area, super admins only).
export const Route = createFileRoute('/_app/platform/')({
  beforeLoad: requireSuperAdmin,
  staticData: { screen: { id: 'SCR-059', title: 'Platform control', group: 'Platform', pin: true, order: 1, platform: true, description: 'Every organisation on this data plane: plan, size, usage and health. Metadata only.', icon: Globe } },
  validateSearch: z.object({
    q: z.string().max(100).optional().catch(undefined),
    status: z.enum(['active', 'suspended', 'closed', 'all']).optional().catch(undefined),
    plan: z.enum(['sandbox', 'team', 'business', 'enterprise', 'all']).optional().catch(undefined),
    flag: z.enum(['payment_failed', 'over_limits', 'suspended', 'closed', 'support_access', 'any']).optional().catch(undefined),
  }),
  component: PlatformControlScreen,
})
